import Tooltip from '@mui/material/Tooltip';
import React from 'react';
import { showSnackbar } from 'v3/data/store/snackbar/actions';
import {
  DisabledTooltipWrapper,
  StyledContactButton,
  StyledEmailIcon,
  StyledPhoneIcon,
} from 'v3/shared/components/ContactIcon/styles';
import { ContactIconProps } from 'v3/shared/components/ContactIcon/types';

const copyToClipboard = async (value: string, label: string) => {
  if (!value) return;

  try {
    await navigator.clipboard.writeText(value);
    showSnackbar(`${label} copiado para a área de transferência`, 'success', true);
  } catch (error) {
    showSnackbar('Não foi possível copiar para a área de transferência.', 'error', true);
  }
};

export const ContactIcon: React.FC<ContactIconProps> = ({ typeContact, value, tooltipWhenMissing }) => {
  const hasValue = !!value && value.trim() !== '';
  const IconComponent = typeContact === 'phone' ? StyledPhoneIcon : StyledEmailIcon;
  const label = typeContact === 'phone' ? 'Telefone' : 'E-mail';

  return (
    <Tooltip title={hasValue ? value : tooltipWhenMissing}>
      <DisabledTooltipWrapper>
        <StyledContactButton
          size="small"
          disabled={!hasValue}
          onClick={hasValue ? () => copyToClipboard(value, label) : undefined}
        >
          <IconComponent />
        </StyledContactButton>
      </DisabledTooltipWrapper>
    </Tooltip>
  );
};
